import { useSyncExternalStore } from 'react'

const MOBILE_BREAKPOINT = 768
const MOBILE_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`

/** S'abonne aux changements de largeur, et rend de quoi se désabonner. */
function subscribe(onChange: () => void): () => void {
  const mql = window.matchMedia(MOBILE_QUERY)
  mql.addEventListener('change', onChange)
  return () => mql.removeEventListener('change', onChange)
}

/**
 * Vrai sur une largeur de téléphone. Lit `matchMedia`, qui est une source
 * extérieure à React.
 *
 * `useSyncExternalStore` plutôt qu'un `useState` + `useEffect` : l'effet ne
 * s'exécutant qu'APRÈS le premier rendu, la valeur y partait à `undefined`,
 * traitée comme « pas mobile ». Un téléphone peignait donc d'abord la mise en
 * page de bureau — barre latérale ouverte — avant de se corriger à l'image
 * suivante. Ici la valeur est lue pendant le rendu, donc juste dès le premier.
 *
 * `matchMedia(...).matches` plutôt que `innerWidth` : c'est la même requête qui
 * décide de la valeur et qui notifie son changement. Les comparer à la main
 * faisait diverger les deux au pixel près du seuil.
 */
export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, () => window.matchMedia(MOBILE_QUERY).matches)
}
